import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Lock } from "lucide-react";
import { useAuth } from "../../lib/auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink grid-lines flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 border border-steel flex items-center justify-center">
            <Lock size={18} className="text-steel" />
          </div>
          <div>
            <p className="overline">Ascendance</p>
            <h1 className="font-heading text-2xl font-bold uppercase tracking-tight text-textmain leading-none">
              Admin Console
            </h1>
          </div>
        </div>

        <form onSubmit={submit} className="bg-panel border border-white/10 p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="overline block mb-3">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="tactical-input"
              placeholder="admin@ascendanceintl.com"
            />
          </div>
          <div>
            <label className="overline block mb-3">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="tactical-input"
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-tactical group w-full disabled:opacity-60">
            {loading ? "Authenticating..." : "Sign In"}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </form>
      </div>
    </div>
  );
}
